import React from 'react'
import { SketchPicker } from 'react-color';

class LabelColorPicker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            displayColorPicker: false
        }

    }

    onLabelClick = () => {
        this.setState({
            displayColorPicker: !this.state.displayColorPicker
        });
    }

    onClose = () => {
        this.setState({
            displayColorPicker: false
        });
    }

    render() {
        const popover = {
            position: 'absolute',
            zIndex: '2',
        }
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        }
        return (
            <div style={{ width: "100%", height: "100%"}}>
                <span onClick={this.onLabelClick} style={{ display: "inline-block", width:"100%", height: "100%", backgroundColor: this.props.color }} ></span>
                {this.state.displayColorPicker ? <div style={popover}>
                    <div style={cover} onClick={this.onClose} />
                    <SketchPicker color={this.props.color} onChangeComplete={this.props.onChangeComplete} />
                </div> : null}
            </div>
        )
    }

}

export default LabelColorPicker